import { render, staticRenderFns } from "./data-empty.vue?vue&type=template&id=c33b7d26&scoped=true"
import script from "./data-empty.vue?vue&type=script&lang=ts"
export * from "./data-empty.vue?vue&type=script&lang=ts"
import style0 from "./data-empty.vue?vue&type=style&index=0&id=c33b7d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33b7d26",
  null
  
)

export default component.exports